import { useQuery } from '@tanstack/react-query';

import APIGateway from '@/api';


export const apiKeysKeys = {
  all: [ 'apiKeys' ] as const,
  list: () => [ ...apiKeysKeys.all, 'list' ] as const,
  listScoped: () => [ ...apiKeysKeys.all, 'list', 'scoped' ] as const
};

export function useApiKeysQuery( opts: { scoped: boolean; enabled?: boolean } ) {
  return useQuery( {
    queryKey: opts.scoped ? apiKeysKeys.listScoped() : apiKeysKeys.list(),
    queryFn: async() => {
      const res = opts.scoped
        ? await APIGateway.apiKeys.apiKeysGetScoped()
        : await APIGateway.apiKeys.apiKeysGet();
      return res.api_keys;
    },
    enabled: opts.enabled ?? true
  } );
}
